// Module generated from Markdown by Markdown Component Loader v1.1.0
import React from 'react';
import PropTypes from 'prop-types';

MarkdownComponent.propTypes = {
  className: PropTypes.string,
  style: PropTypes.object
};

function MarkdownComponent(props) {
  const { className, style } = props;

  return (
    <div className={className} style={style}>
      <h3 id="may-24-2021">May 24, 2021</h3>
      <p>(v1) We have turned back on the new Veteran first and last name field validations described in the May 17 release notes. In addition to these new validations, we will allow spaces in these fields, including leading and trailing spaces (white space). #6986</p>
      <p><a href="https://github.com/department-of-veterans-affairs/vets-api/pull/6986">#6986</a></p>
      <hr />
      <h3 id="may-20-2021">May 20, 2021</h3>
      <p>(v1) On May 17, we made changes to Veteran First and Last name field validations for the Benefits Intake API, which are described in a release note below.</p>
      <p>Based on the high number of errors being received, we are temporarily turning off these changes and reverting back to previous field requirements. We are working on updating the new validations to allow spaces and reduce the number of errors returned.</p>
      <p>When those changes are made, we will turn on the new validations, post an updated release note, and send a notification to all consumers.</p>
      <hr />
      <h3 id="may-17-2021">May 17, 2021</h3>
      <p>(v1) In order to further automate matches of submitted documents with Veterans downstream, the required Veteran First and Last name metadata fields now only allow alpha characters, dashes -, and forward slashes /. Additionally, these fields must be less than or equal to 50 characters. No numbers or other special characters may be submitted in these fields.</p>
      <p>{'Submissions with invalid characters will receive Error Status DOC102\t"Invalid Veteran name (e.g. empty, invalid characters, or too long). Names must match the regular expression /^[a-zA-Z-/]{1,50}$/"'}</p>
      <p><a href="https://github.com/department-of-veterans-affairs/vets-api/pull/6882">#6882</a></p>
      <hr />
      <h3 id="april-2-2021">April 2, 2021</h3>
      <p>(v1) We added new error detail messages that provide additional detail for a small number of submissions returning the DOC202 ERROR code.</p>
      <ul>
      <li>Unidentified Mail: We could not associate this submission with a Veteran. Please verify the identifying information and resubmit.</li>
      <li>Duplicate Submission: This document was already uploaded, faxed, or mailed and was or is being processed. This is a duplicate submission and will not be processed.</li>
      <li>Blank Document: The attachment contains no content. Please verify the attachment and resubmit, if needed.</li>
      </ul>
      <hr />
      <h3 id="march-29-2021">March 29, 2021</h3>
      <p>(v0) Version 0.0.1 of the Benefits Intake API was removed on March 29, 2021. Refer to <a href="https://developer.va.gov/explore/benefits/docs/benefits?version=current">version 1.0.0</a> of the API and related documentation. For more information, <a href="https://developer.va.gov/support/contact-us">contact us</a> or visit our <a href="https://groups.google.com/forum/m/#!forum/va-lighthouse">Google Developer Forum</a>.</p>
      <hr />
      <h3 id="march-1-2021">March 1, 2021</h3>
      <p>(v1) The Benefits-Intake API now has a new claim/benefit selection option to help ensure submissions reach the correct business line so they can be processed as quickly as possible: <a href="https://github.com/department-of-veterans-affairs/vets-api/pull/6037">#6037</a></p>
      <p>The existing businessLine metadata field can be empty, or it can contain the code to indicate a document is related to one of these claim/benefit types:</p>
      <p>CMP – Compensation requests such as those related to disability, unemployment, and pandemic claims<br />
      PMC – Pension requests including survivor’s pension<br />
      INS – Insurance such as life insurance, disability insurance, and other health insurance<br />
      EDU – Education benefits, programs, and affiliations<br />
      VRE – Veteran Readiness &amp; Employment such as employment questionnaires, employment discrimination, employment verification<br />
      BVA – Board of Veteran Appeals<br />
      FID – Fiduciary/financial appointee, including family member benefits<br />
      OTH – Other (which will be routed to CMP)</p>
      <p>This change is currently optional, but may become a required field in a future iteration of the API.</p>
      <hr />
      <h3 id="november-30-2020">November 30, 2020</h3>
      <p>(v1) Added uploaded PDF metadata (page count, total pages, document count, and document dimensions) to the DB and in the HTTP response:</p>
      <ul>
      <li>Database migration <a href="https://github.com/department-of-veterans-affairs/vets-api/pull/5380">#5380</a></li>
      <li>JSON metadata stored in DB and added to the status check response <a href="https://github.com/department-of-veterans-affairs/vets-api/pull/5303">#5303</a></li>
      </ul>
      <hr />
      <h3 id="october-7-2019">October 7, 2019</h3>
      <p>(v0 &amp; v1) Add support for base64 encoding <a href="https://github.com/department-of-veterans-affairs/vets-api/pull/3395">#3995</a></p>
      <hr />
      <h3 id="august-19-2019">August 19, 2019</h3>
      <p>(v0 &amp; v1) Validation on document page size <a href="https://github.com/department-of-veterans-affairs/vets-api/pull/3213">#3213</a></p>
      <hr />
      <h3 id="july-29-2019">July 29, 2019</h3>
      <p>(v0 &amp; v1) New <code>expired</code> status added to individual status endpoint <a href="https://github.com/department-of-veterans-affairs/vets-api/pull/3353">#3353</a></p>
      <hr />
      <h3 id="july-24-2019">July 24, 2019</h3>
      <p>(v0 &amp; v1) Cache statuses for /uploads/report endpoint <a href="https://github.com/department-of-veterans-affairs/vets-api/pull/3158">#3158</a></p>
      <hr />
      <h3 id="july-11-2019">July 11, 2019</h3>
      <p>(v1) Revert changes to error handling <a href="https://github.com/department-of-veterans-affairs/vets-api/pull/3150">#3150</a></p>
      <hr />
      <h3 id="july-9-2019">July 9, 2019</h3>
      <p>(v1) Announced support for v1, which includes 2 breaking changes:</p>
      <ul>
      <li>&quot;vbms&quot; status <a href="https://github.com/department-of-veterans-affairs/vets-api/pull/3027">#3027</a></li>
      <li>Updates to error handling <a href="https://github.com/department-of-veterans-affairs/vets-api/pull/3053">#3053</a></li>
      </ul>
      <hr />
      <h3 id="june-11-2019">June 11, 2019</h3>
      <p>(v0 &amp; v1) Adding Metadata Endpoints for V0 and V1 end points <a href="https://github.com/department-of-veterans-affairs/vets-api/pull/3093">#3093</a></p>
      <hr />
      <h3 id="june-3-2019-benefits-intake">June 3, 2019</h3>
      <p>(v0) Upgrade Ruby to 2.4.5 <a href="https://github.com/department-of-veterans-affairs/vets-api/pull/2995">#2995</a></p>
      <hr />
      <h3 id="may-28-2019-benefits-intake">May 28, 2019</h3>
      <p>(v0) Rails 5.2.3 <a href="https://github.com/department-of-veterans-affairs/vets-api/pull/2933">#2933</a></p>
      <hr />
      <h3 id="may-23-2019">May 23, 2019</h3>
      <p>(v0) Create self-service testing tool <a href="https://github.com/department-of-veterans-affairs/vets-api/pull/3059">#3059</a></p>
      <hr />
      <h3 id="may-3-2019">May 3, 2019</h3>
      <p>(v0) Validate Against Empty Files <a href="https://github.com/department-of-veterans-affairs/vets-api/pull/3025">#3025</a></p>
      <hr />
      <h3 id="may-1-2019-benefits-intake">May 1, 2019</h3>
      <p>(v0) Rails 5.1 <a href="https://github.com/department-of-veterans-affairs/vets-api/pull/2897">#2897</a></p>
      <hr />
      <h3 id="april-9-2019-benefits-intake">April 9, 2019</h3>
      <p>(v0) Upgrade API to Rails 5.0.7.2 <a href="https://github.com/department-of-veterans-affairs/vets-api/pull/2833">#2833</a></p>
      <hr />
      <h3 id="march-18-2019">March 18, 2019</h3>
      <p>(v0) Handle new vbms success status without passing it along to consumers (would be a breaking change) <a href="https://github.com/department-of-veterans-affairs/vets-api/pull/2877">#2877</a></p>
      <hr />
      <h3 id="january-28-2019">January 28, 2019</h3>
      <p>(v0) Status simulation in Developer environment <a href="https://github.com/department-of-veterans-affairs/vets-api/pull/2751">#2751</a></p>
      <ul>
      <li>Can now specify status in developer environment, and receive mocked data for that status.</li>
      </ul>
      <hr />
      <h3 id="october-8-2018">October 8, 2018</h3>
      <p>(v0) Update API URLs to va.gov domains in documentation <a href="https://github.com/department-of-veterans-affairs/vets-api/pull/2332">#2332</a></p>
      <hr />
      <h3 id="september-18-2018">September 18, 2018</h3>
      <p>(v0) Implement VA-required logging for uploads <a href="https://github.com/department-of-veterans-affairs/vets-api/pull/2072">#2072</a></p>
      <hr />
      <h3 id="august-27-2018">August 27, 2018</h3>
      <p>(v0) Validating PDF format on upload <a href="https://github.com/department-of-veterans-affairs/vets-api/pull/2213">#2213</a></p>
      <hr />
      <h3 id="july-23-2018">July 23, 2018</h3>
      <p>(v0) Limit the size of individual attachments in uploads <a href="https://github.com/department-of-veterans-affairs/vets-api/pull/2094">#2094</a></p>
      <hr />
      <h3 id="july-19-2018">July 19, 2018</h3>
      <ul>
      <li>(v0) Improve pension and burial claim uploads to Central Mail <a href="https://github.com/department-of-veterans-affairs/vets-api/pull/2143">#2143</a></li>
      <li>(v0) Add Consumer ID to Central Mail upload submission <a href="https://github.com/department-of-veterans-affairs/vets-api/pull/2071">#2071</a></li>
      </ul>
      <hr />
      <h3 id="july-2-2018">July 2, 2018</h3>
      <p>(v0) Add Amazon SNS support to endpoint <a href="https://github.com/department-of-veterans-affairs/vets-api/pull/2058">#2058</a></p>
      <hr />
      <h3 id="june-8-2018">June 8, 2018</h3>
      <p>(v0) Add numeric-characters-only validation to fileNumber metadata element <a href="https://github.com/department-of-veterans-affairs/vets-api/pull/2020">#2020</a></p>
      <hr />
      <h3 id="may-17-2018">May 17, 2018</h3>
      <p>(v0) Add bulk status report <a href="https://github.com/department-of-veterans-affairs/vets-api/pull/1947">#1947</a></p>
      <hr />
      <h3 id="may-8-2018">May 8, 2018</h3>
      <p>(v0) Start uploading documents to Central Mail <a href="https://github.com/department-of-veterans-affairs/vets-api/pull/1896">#1896</a></p>
      <hr />
      <h3 id="april-26-2018">April 26, 2018</h3>
      <p>(v0) Start retrieving statuses from Central Mail <a href="https://github.com/department-of-veterans-affairs/vets-api/pull/1887">#1887</a></p>
      <hr />
      <h3 id="april-20-2018">April 20, 2018</h3>
      <p>(v0) Create initial service <a href="https://github.com/department-of-veterans-affairs/vets-api/pull/1887">#1887</a></p>
    </div>
  );
};

export default MarkdownComponent;
